module.exports = __webpack_public_path__ + "static/media/agricultural16.1cafa5e7.jpg";